import { PAGE_SIZE_OPTIONS } from '@lib/constants/coveo';

/**
 * Resolve the INCREASE_DEFAULT_RESULTS_PER_PAGE payload to an engine-valid
 * page size, or undefined when the payload is missing or invalid. Every
 * consumer (the SSR page seeding its first query, the CSR controls applying
 * the flag after mount) must validate through this one function: divergent
 * checks would silently run the two search arms at different page sizes.
 * Coerces numeric strings, then requires an exact PAGE_SIZE_OPTIONS entry —
 * the page-size dropdown can only render those.
 */
export function resolveFlagPageSize(payload: unknown): number | undefined {
  const pageSize = Number(
    (payload as { pageSize?: unknown } | undefined)?.pageSize
  );
  return PAGE_SIZE_OPTIONS.includes(pageSize) ? pageSize : undefined;
}
